const primary = '#3e4e6e';

export default {
  primary,
}
